<div class="dialog-header">
  <mat-toolbar id="dialog-titlebar" color="primary" mat-dialog-title> Notes </mat-toolbar>
</div>
<div mat-dialog-content class="dialog-content">
  <div class="list-container" *ngIf="!hideSideNav"
    [ngClass]="{'detail-notes': objectName==='Detail' || objectName === 'AssayName' || objectName === 'Cassette'}">
    <mat-tab-group #tabGroup class="small-tabs "
      *ngIf="objectName==='Detail' || objectName === 'AssayName' || objectName === 'Cassette'"
      data-testid="dialog-notes-tabgroup"
      [(selectedIndex)]="selectedIndexTab" (selectedTabChange)="onTabChange()">
      <mat-tab label="One time note" *ngIf="objectName !== 'AssayName' && objectName !== 'Cassette'">
        <div class="tab-content">
          <mat-form-field appearance="outline" class="search-bar-field" subscriptSizing="dynamic">
            <mat-label>Search</mat-label>
            <input matInput type="text" data-testid="dialog-notes-search-input" [(ngModel)]="searchKey" placeholder="Search" autocomplete="off"
              (ngModelChange)="onSearchChange($event)" #searchInput />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
          <mat-card class="note-card" [class.selected]="note.selected" (click)="onClickNote(note)"
            *ngFor="let note of filteredList">
            <mat-card-title>{{ note.noteTitle }}</mat-card-title>
            <mat-card-content>
              {{ note.noteText }}
            </mat-card-content>
            <mat-card-actions>
              <div class="note-author">{{ note.createdByName }}</div>
              <div class="note-date">{{ note.dateCreated | date: 'short' }}</div>
            </mat-card-actions>
          </mat-card>
        </div>
      </mat-tab>
      <mat-tab label="Live note">
        <div class="tab-content">
          <mat-card class="note-card live-note-card">
            <mat-card-title>{{ liveNote?.noteTitle }}</mat-card-title>
            <mat-card-content #liveNoteContent>
              {{ liveNote?.noteText }}
              <span class="ellipsis" *ngIf="checkOverflow()">...</span>
            </mat-card-content>
            <mat-card-actions>
              <ng-container *ngIf="!liveNote?.dateModified">
                <div class="note-author">Created by {{ liveNote?.createdByName }}</div>
                <div class="note-date">{{ liveNote?.dateCreated | date: 'short' }}</div>
              </ng-container>

              <ng-container *ngIf="liveNote?.dateModified">
                <div class="note-author">Updated by {{ liveNote?.modifiedByName }}</div>
                <div class="note-date">{{ liveNote?.dateModified | date: 'short' }}</div>
              </ng-container>
            </mat-card-actions>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
    <ng-container *ngIf="objectName!=='Detail' && objectName!=='AssayName' && objectName!=='Cassette'">
      <mat-form-field appearance="outline" class="search-bar-field" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput type="text" data-testid="dialog-notes-secondary-search-input" [(ngModel)]="searchKey" placeholder="Search" autocomplete="off"
          (ngModelChange)="onSearchChange($event)" #searchInput />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-card class="note-card" [class.selected]="note.selected" (click)="onClickNote(note)"
        *ngFor="let note of filteredList">
        <mat-card-title>{{ note.noteTitle }}</mat-card-title>
        <mat-card-content>
          {{ note.noteText }}
        </mat-card-content>
        <mat-card-actions>
          <div class="note-author">{{ note.createdByName }}</div>
          <div class="note-date">{{ note.dateCreated | date: 'short' }}</div>
        </mat-card-actions>
      </mat-card>
    </ng-container>

  </div>
  <div class="note-container">
    <div class="note-detail">
      <mat-form-field appearance="outline" class="note-title-field" subscriptSizing="dynamic">
        <mat-label>Title</mat-label>
        <textarea matInput placeholder="Add Title" data-testid="dialog-notes-title-input" [(ngModel)]="noteTitle" class="note-title-input"
          [disabled]="!addMode" maxlength="100" #titleTextarea cdkFocusInitial
          [disabled]="!(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')">
        </textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" class="note-body-field" subscriptSizing="dynamic">
        <mat-label>Note</mat-label>
        <textarea matInput placeholder="Add Note" data-testid="dialog-notes-body-input" [(ngModel)]="noteBody" class="note-body-input"
          [disabled]="!addMode || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus')"
          #bodyTextarea>
        </textarea>
      </mat-form-field>
    </div>
    <div class="dialog-actions">
      <button mat-raised-button color="warn" data-testid="dialog-notes-close-button" (click)="closeNoteHandler()">Close</button>
      <button mat-raised-button color="primary" data-testid="dialog-notes-save-button" (click)="!addMode ? addNoteHandler() : saveNoteHandler()"
        [disabled]="addMode && !(!!noteTitle && !!noteBody) || !(currentRoles | hasAnyRoles : ['WRITER','READER'] : currentExperiment : 'IsAnyStatus') || isSaving">
        {{ !addMode ? 'Add' : 'Save' }}
      </button>
    </div>
  </div>
</div>